import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      testId="terms-page"
      kicker="Document N°02 · Terms"
      title="Terms of Service."
      updated="December 2025"
    >
      <p>
        These Terms of Service (&ldquo;<strong>Terms</strong>&rdquo;) govern
        your access to and use of the <strong>RTAMA LTD</strong> website and
        any related services. By using this site, you agree to be bound by
        these Terms.
      </p>

      <h2>1. The company</h2>
      <p>
        <strong>RTAMA LTD</strong>, registration number{" "}
        <strong>HE433506</strong>, is a private limited company registered in
        the Republic of Cyprus, with registered office at:
      </p>
      <p>
        Griva Digeni Avenue 51, Athineon Court, Office 202, 8047, Paphos,
        Cyprus.
      </p>
      <p>
        Contact: <a href="mailto:rtamaltd@gmail.com">rtamaltd@gmail.com</a>.
      </p>

      <h2>2. Use of the website</h2>
      <p>
        You agree to use the website lawfully and not to misuse, reverse
        engineer, or attempt to gain unauthorised access to any part of it. We
        reserve the right to restrict or terminate access at our sole
        discretion.
      </p>

      <h2>3. Intellectual property</h2>
      <p>
        All content on this website — including text, design, logos,
        photographs, and code — is owned by or licensed to RTAMA LTD and
        protected by intellectual property laws. You may not reproduce or
        redistribute it without our prior written consent.
      </p>

      <h2>4. Services & engagement</h2>
      <p>
        Any actual engagement of our influencer management services is
        governed by a separate, signed agreement. Information on this website
        is provided for general purposes only and does not constitute a
        binding offer.
      </p>

      <h2>5. Third-party content</h2>
      <p>
        The website may link to or display third-party content. We are not
        responsible for the practices or content of any third party.
      </p>

      <h2>6. Disclaimer</h2>
      <p>
        The website is provided &ldquo;as is&rdquo; without warranties of any
        kind. We do not guarantee uninterrupted availability or error-free
        operation.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, RTAMA LTD shall not be liable
        for any indirect, incidental, special, consequential, or punitive
        damages arising out of your use of the website.
      </p>

      <h2>8. Governing law &amp; jurisdiction</h2>
      <p>
        These Terms are governed by the laws of the Republic of Cyprus. Any
        dispute shall be subject to the exclusive jurisdiction of the courts
        of Cyprus, without prejudice to your mandatory consumer rights.
      </p>

      <h2>9. Changes</h2>
      <p>
        We may update these Terms periodically. Continued use of the website
        after changes are posted constitutes acceptance of the updated Terms.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these Terms? Email{" "}
        <a href="mailto:rtamaltd@gmail.com">rtamaltd@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
